/**
 * Form to localStorage
 * Saves form data in real-time as the user types
 */
(function() {
  // Function to save form data to localStorage
  function saveFormData() {
    const firstName = document.getElementById('RegisterForm-FirstName')?.value || '';
    const lastName = document.getElementById('RegisterForm-LastName')?.value || '';
    const email = document.getElementById('RegisterForm-email')?.value || '';
    const phone = document.getElementById('RegisterForm-phone')?.value || '';
    
    let city = '';
    const citySelect = document.getElementById('RegisterForm-city');
    if (citySelect) {
      city = citySelect.value;
      if (city === 'Autre') {
        const otherCity = document.getElementById('RegisterForm-other-city')?.value || '';
        if (otherCity) {
          city = otherCity;
        }
      }
    }
    
    const address = document.getElementById('RegisterForm-address')?.value || '';
    
    // Create the data object
    const formData = {
      name: firstName + (lastName ? ' ' + lastName : ''),
      email: email,
      phone: phone,
      city: city,
      address: address
    };
    
    // Save to localStorage
    try {
      localStorage.setItem('easysell_customer_data', JSON.stringify(formData));
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }
  
  // Initialize the form listeners when the DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // Get all the form fields
    const formFields = [
      'RegisterForm-FirstName',
      'RegisterForm-LastName',
      'RegisterForm-email',
      'RegisterForm-phone',
      'RegisterForm-city',
      'RegisterForm-other-city',
      'RegisterForm-address'
    ];
    
    // Add input/change event listeners to each field
    formFields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.addEventListener('input', saveFormData);
        field.addEventListener('change', saveFormData);
      }
    });
    
    // Show/hide the "Other city" field based on city selection
    const citySelect = document.getElementById('RegisterForm-city');
    const otherCityField = document.getElementById('other-city-field');
    
    if (citySelect && otherCityField) {
      citySelect.addEventListener('change', function() {
        if (this.value === 'Autre') {
          otherCityField.style.display = 'block';
        } else {
          otherCityField.style.display = 'none';
        }
        saveFormData();
      });
    }
  });
})();